export const ICS2_ENS_DataStructure = {
    documentIssueDate: {},
    splitConsignment: {},
    representative: {},
    activeBorderTransportMeans: {},
    declarant: {},
    customsOfficeOfFirstEntry: {},
    consignmentMasterLevel: {
        referenceNumberUCR: {},
        consignor: {},
        consignee: {},
        notifyParty: {},
        carrier: {},
        placeOfAcceptance: {},
        placeOfLoading: {},
        placeOfUnloading: {},
        placeOfDelivery: {},
        transportCharges: {},
        transportDocumentMasterLevel: {},
        transportEquipment: [],
        supportingDocuments: [],
        additionalInformation: [],
        additionalSupplyChainActor: [],
    },
};

export const ICS2_ENS_HouseConsignmentDataStructure = {
    referenceNumberUCR: {},
    consignor: {},
    consignee: {},
    notifyParty: {},
    placeOfAcceptance: {},
    placeOfDelivery: {},
    transportCharges: {},
    transportDocumentHouseLevel: {},
    transportEquipment: [],
    passiveBorderTransportMeans: [],
    countriesOfRoutingOfConsignment: [],
    supportingDocuments: [],
    additionalInformation: [],
    additionalSupplyChainActor: [],
    goodsShipment: {},
};

export const ICS2_ENS_ItemDataStructure = {
    commodity: {},
    weight: {},
    packaging: [],
    transportEquipment: [],
    supportingDocuments: [],
    additionalInformation: [],
    additionalSupplyChainActor: [],
    passiveBorderTransportMeans: [],
};
